module.exports = __webpack_public_path__ + "img/pic1.644133e6.png";